import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=c12f760c&"
import script from "./coming-soon.vue?vue&type=script&lang=js&"
export * from "./coming-soon.vue?vue&type=script&lang=js&"
import style0 from "./coming-soon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports